import { DataStorageResponse } from '../../../types/DataStorage'
import { RootState } from '../types'

export const FETCH_DATASTORAGE_PENDING =
  'dataStorage//FETCH_DATASTORAGE_PENDING'
export const FETCH_DATASTORAGE_DONE = 'dataStorage//FETCH_DATASTORAGE_DONE'
export const FETCH_DATASTORAGE_ERROR = 'dataStorage//FETCH_DATASTORAGE_ERROR'

interface DataStorageState {
  pending: boolean
  data: DataStorageResponse | Record<string, never>
  error: boolean | null
  prepopulatedGroupId: boolean | null
}

interface PendingAction {
  type: typeof FETCH_DATASTORAGE_PENDING
  payload: Record<string, never>
}

interface DoneAction {
  type: typeof FETCH_DATASTORAGE_DONE
  payload: {
    data: DataStorageResponse
  }
}

interface ErrorAction {
  type: typeof FETCH_DATASTORAGE_ERROR
  payload: {
    err: unknown
  }
}

export type DataStorageActions = PendingAction | DoneAction | ErrorAction

export function pending(): PendingAction {
  return {
    type: FETCH_DATASTORAGE_PENDING,
    payload: {},
  }
}

export function done(data: DataStorageResponse): DoneAction {
  return {
    type: FETCH_DATASTORAGE_DONE,
    payload: {
      data,
    },
  }
}

export function error(err: unknown): ErrorAction {
  return {
    type: FETCH_DATASTORAGE_ERROR,
    payload: {
      err,
    },
  }
}

export function getDataStorageData(store: RootState): DataStorageState['data'] {
  return store.dataStorage.data
}

export function getPrepolulatedGroupIdFlag(
  store: RootState
): DataStorageState['prepopulatedGroupId'] {
  return store.dataStorage.prepopulatedGroupId
}

const initialState: DataStorageState = {
  pending: false,
  data: {},
  error: null,
  prepopulatedGroupId: null,
}

// eslint-disable-next-line func-names
export default function dataStorageReducer(
  state: DataStorageState | undefined,
  action: DataStorageActions
): DataStorageState {
  const currentState = state || initialState
  switch (action.type) {
    case FETCH_DATASTORAGE_PENDING:
      return {
        ...currentState,
        data: {},
        pending: true,
        error: null,
      }

    case FETCH_DATASTORAGE_DONE:
      return {
        ...currentState,
        data: action.payload.data,
        pending: false,
        error: null,
        prepopulatedGroupId:
          currentState.prepopulatedGroupId === null
            ? Boolean(
                action?.payload?.data?.data?.dealerData?.groupId &&
                  action?.payload?.data?.data?.vehicleData?.vin
              )
            : currentState.prepopulatedGroupId,
      }
    case FETCH_DATASTORAGE_ERROR:
      return {
        ...currentState,
        data: {},
        pending: false,
        error: true,
      }

    default:
      return currentState
  }
}
